import React from 'react';
import links from '../../../data/links.json';
import products from '../../../data/products.json';
import Heading from './Heading';
import Item from './Item';

const Products = () => {
  return (
    <div id="products" className="py-16 overflow-hidden mb-8">
      <Heading />
      <div className="relative max-w-screen-lg px-4 mx-auto sm:px-6 lg:px-16">
        <div className="mt-12 overflow-hidden bg-white shadow sm:rounded-md">
          <ul>
            {Object.keys(products)
              .filter((sku) => sku !== 'GA12' && sku !== 'GA05')
              .map((sku, index) => {
                const { name, link, icons, short, description } = products[sku];
                return (
                  <Item
                    key={sku}
                    isFirst={index === 0}
                    link={link}
                    images={icons}
                    title={short || name}
                  >
                    {description}
                  </Item>
                );
              })}
          </ul>
        </div>
      </div>
      <p className="max-w-md mx-auto md:text-base text-center text-gray-500 sm:text-lg mt-16 md:max-w-3xl">
        All products are designed and developed by Google Developer
        Expert,&nbsp;
        <a
          className="font-semibold border-b-2 border-indigo-500 py-1"
          href={links.DEVELOPER}
          target="_blank"
          rel="noopener noreferrer"
        >
          Amit Agarwal
        </a>
      </p>
    </div>
  );
};
export default Products;
